import { doc as firestoreDoc, updateDoc, increment, serverTimestamp, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Atualiza um contador em uma entidade, garantindo atomicidade
 * @param {string} collectionPath - Caminho da coleção (ex: 'salons/{salonId}/professionals')
 * @param {string} docId - ID do documento
 * @param {string} counterField - Nome do campo contador
 * @param {number} delta - Valor a incrementar/decrementar
 * @param {string} [timestampField='updatedAt'] - Campo de timestamp a atualizar
 * @returns {Promise<void>}
 */
export const updateCounter = async (collectionPath, docId, counterField, delta, timestampField = 'updatedAt') => {
  try {
    const docRef = firestoreDoc(db, `${collectionPath}/${docId}`);
    const updateData = {
      [counterField]: increment(delta)
    };
    
    if (timestampField) {
      updateData[timestampField] = serverTimestamp();
    }
    
    await updateDoc(docRef, updateData);
    return true;
  } catch (error) {
    console.error(`Erro ao atualizar contador ${counterField} em ${collectionPath}/${docId}:`, error);
    return false;
  }
};

/**
 * Valida se um ID existe em uma coleção
 * @param {string} collectionPath - Caminho da coleção
 * @param {string} docId - ID do documento
 * @returns {Promise<boolean>} - true se o documento existe
 */
export const validateEntityExists = async (collectionPath, docId) => {
  try {
    const docRef = firestoreDoc(db, `${collectionPath}/${docId}`);
    const docSnap = await getDoc(docRef);
    return docSnap.exists();
  } catch (error) {
    console.error(`Erro ao validar existência de ${collectionPath}/${docId}:`, error);
    return false;
  }
};

/**
 * Gera um ID de associação concatenando professionalId e serviceId
 * @param {string} professionalId 
 * @param {string} serviceId 
 * @returns {string}
 */
export const generateAssociationId = (professionalId, serviceId) => {
  return `${professionalId}_${serviceId}`;
};

/**
 * Logger estruturado para operações de banco de dados
 * @param {string} operation - Nome da operação
 * @param {string} entity - Entidade afetada
 * @param {string} id - ID da entidade
 * @param {Object} details - Detalhes adicionais
 */
export const logOperation = (operation, entity, id, details = {}) => {
  console.log(`[${operation}] ${entity} ${id}:`, details);
}; 